import React from "react";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";

import AvatarsImage from "../../../assets/images/png/home/avatars.webp";

import SchoolImage from "../../../assets/images/png/school/data-school.webp";

import * as Animate from "react-reveal";
import { Link } from "react-router-dom";

const SchoolHeader = ({ selectedLocation, selectedSchoolData }) => {
  return (
    <>
      <header
        className={`pb-16 ${
          selectedLocation?.name === "Africa" || !selectedLocation
            ? "school-header-section"
            : "school-header-section-2"
        }`}
      >
        <HeaderNavigation
          bgdark={
            selectedLocation?.name === "Africa" || !selectedLocation
              ? false
              : true
          }
        />
        <div className="pt-2 md:pt-16 container px-4 mx-auto">
          <div className="relative flex flex-wrap flex-row">
            <div className="w-full lg:w-6/12 mb-8">
              <Animate.Fade bottom>
                <h2 className="school-header-intro text-secondary font-mono text-2xl md:text-3xl lg:text-3xl font-semibold leading-snug mt-6">
                  Welcome to Utiva
                </h2>
                <h2 className="mt-4 text-primary font-mono text-5xl md:text-6xl lg:text-7xl font-semibold ">
                  {selectedSchoolData.name}
                </h2>
                <p className="school-header-content text-default pt-8 w-full lg:w-11/12 xl:w-10/12 text-base lg:text-lg lg:leading-8">
                  {selectedSchoolData.description}
                </p>
              </Animate.Fade>

              <div className="pt-12">
                <Animate.Fade bottom>
                  <div className="flex flex-row items-center">
                    <img
                      src={AvatarsImage}
                      className="w-16 lg:w-20"
                      alt="People"
                    />

                    <p className="pl-4 font-mono text-xs lg:text-sm text-gray learner">
                      Over 110k+ professionals trained.{" "}
                      <Link to="/stories" className="font-medium text-primary">
                        Read stories
                      </Link>
                    </p>
                  </div>
                </Animate.Fade>
              </div>
            </div>
            <div className="w-full lg:w-6/12 relative rounded-md lg:pl-12">
              <div className="relative block">
                <img
                  src={selectedSchoolData?.image || SchoolImage}
                  width="100%"
                  height="100%"
                  alt=""
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="flex flex-row w-full relative">
        <div className="w-6/12 bg-secondary h-2" />
        <div
          className="w-6/12 bg-[#61DB99] h-2"
          style={{ background: "#61DB99" }}
        />
      </div>
    </>
  );
};

export default SchoolHeader;
